function getVariation(name) {
  const len = name.length;
  if (len > 42) return 0.65;
  if (len > 38) return 0.75;
  if (len > 34) return 0.8;
  if (len > 30) return 0.85;
  if (len > 26) return 0.9;
  if (len > 22) return 0.95;
  if (len > 18) return 1;
  if (len > 14) return 1.05;
  if (len > 12) return 1.1;
  if (len > 10) return 1.15;
  if (len > 8) return 1.2;
  if (len > 6) return 1.25;
  if (len > 4) return 1.3;
  return 1.4;
}

export function calcFontSizeByNameLength(name, baseFontSize) {
  baseFontSize = Number(baseFontSize);
  const variation = getVariation(name);
  return Math.floor(baseFontSize * variation).toString();
}

function getBaseFontSize(product) {
  const { fontSize, baseFontSize } = product.styles;
  const variation = getVariation(product.name);
  // A mismatch means fontSize was changed elsewhere, so the stored base is stale.
  if (baseFontSize && Math.floor(baseFontSize * variation) === Number(fontSize))
    return baseFontSize;
  return Math.round(Number(fontSize) / variation);
}

/** Puts the content of contentProduct into slotProduct's styles, resizing the font for the new name. */
export function moveProductIntoSlot(contentProduct, slotProduct) {
  const baseFontSize = getBaseFontSize(slotProduct);
  return {
    ...contentProduct,
    styles: {
      ...slotProduct.styles,
      baseFontSize,
      fontSize: calcFontSizeByNameLength(contentProduct.name, baseFontSize),
    },
  };
}

export function mapProductsWithFontSize(products) {
  return products.map((product) => {
    const fontSize = calcFontSizeByNameLength(
      product.name,
      product.styles.fontSize,
    );
    return {
      ...product,
      styles: {
        ...product.styles,
        fontSize: fontSize,
      },
    };
  });
}
